var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26396_250487)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8041 28.8534C27.1608 28.8534 25.8287 27.5352 25.8287 25.9093C25.8287 24.2831 27.1608 22.9648 28.8041 22.9648C30.4473 22.9648 31.7794 24.2831 31.7794 25.9093C31.7794 27.5352 30.4473 28.8534 28.8041 28.8534ZM29.6948 20.2408V17.6215C30.3857 17.2986 30.8696 16.607 30.8696 15.8043V15.7439C30.8696 14.6361 29.9537 13.7298 28.8343 13.7298H28.7735C27.6541 13.7298 26.7383 14.6361 26.7383 15.7439V15.8043C26.7383 16.607 27.2222 17.2989 27.9131 17.6218V20.2408C26.8844 20.3981 25.9446 20.818 25.1695 21.4358L17.9024 15.8416C17.9504 15.6594 17.9841 15.4718 17.9844 15.2746C17.9855 14.0202 16.9595 13.0017 15.6913 13C14.4238 12.9986 13.3943 14.0143 13.3929 15.2689C13.3915 16.5236 14.4175 17.5421 15.6856 17.5435C16.0987 17.5441 16.4813 17.428 16.8164 17.2392L23.9648 22.7425C23.357 23.6505 23.0007 24.7382 23.0007 25.9093C23.0007 27.1351 23.3921 28.2692 24.0533 29.2018L21.8796 31.3532C21.7077 31.3021 21.5296 31.2665 21.3406 31.2665C20.2988 31.2665 19.4541 32.1022 19.4541 33.1331C19.4541 34.1643 20.2988 35 21.3406 35C22.3826 35 23.2271 34.1643 23.2271 33.1331C23.2271 32.9466 23.1911 32.7701 23.1394 32.6L25.2897 30.472C26.2658 31.2091 27.4814 31.6521 28.8041 31.6521C32.0092 31.6521 34.6072 29.0809 34.6072 25.9093C34.6072 23.038 32.4757 20.666 29.6948 20.2408Z",
    fill: "#FF7A59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26396_250487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2143,
    height: 22,
    fill: "white",
    transform: "translate(13.3929 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/Hubspot.1439c98f53e383a4ab23931c0bd8b600.svg";
export { ForwardRef as ReactComponent };